import { queryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { ApiError } from "@/core/api/types";
import usePublicApi from "@/core/api/usePublicApi";

export type PublicDocumentKind = "invoice" | "receipt";

export const publicPdfKeys = {
  status: (kind: PublicDocumentKind, documentId: string) =>
    ["ap", "public-pdf", kind, documentId] as const,
};

export const publicPdfStatusOptions = (
  api: AxiosInstance,
  kind: PublicDocumentKind,
  documentId: string,
) =>
  queryOptions({
    queryKey: publicPdfKeys.status(kind, documentId),
    queryFn: async (): Promise<string | null> => {
      try {
        const res = await api.get<{ pdf_url: string }>(
          `/public/ap/${kind}s/${encodeURIComponent(documentId)}`,
        );
        return res.data.pdf_url;
      } catch (error) {
        if (error instanceof ApiError && error.status === 404) return null;
        throw error;
      }
    },
    retry: false,
    staleTime: Infinity,
  });

export const usePublicPdfStatus = (
  kind: PublicDocumentKind,
  documentId: string,
) => {
  const api = usePublicApi();
  return useQuery(publicPdfStatusOptions(api, kind, documentId));
};
